var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Email',{attrs:{"to":_vm.to,"value":_vm.emailValue},on:{"input":function($event){return _vm.emitEmail($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }